<ef-burden-filters-presenter
    [contracts]="contracts"
    (SelectContract)="SelectContract.emit($event)"
    (ToggleDetails)="ToggleDetails.emit($event)"
></ef-burden-filters-presenter>
